import styled from "@emotion/styled";
import { ThemeKey } from "@smartsheet/design-tokens";
import { createContext } from "@smartsheet/lodestar-utils";
import React, { ReactNode, useMemo } from "react";
import { ThemeObject } from "./types";
import { getTheme } from "./utils/getTheme";
import { getThemeClasses } from "./utils/getThemeClasses";

export const SDSThemeContext = createContext<ThemeObject>({} as ThemeObject, "SDSThemeContext");

interface SDSThemeProviderProps {
    children: ReactNode;
    themeKey: ThemeKey;
    innerWrapperStyles?: React.CSSProperties;
}

interface StyledThemeProviderProps {
    innerWrapperStyles?: React.CSSProperties;
}

const StyledThemeProvider = styled.div<StyledThemeProviderProps>`
    position: inherit;
    width: inherit;
    height: inherit;
    display: inherit;
    ${(props) => {
        return {
            ...props.innerWrapperStyles,
        };
    }}
`;

export const SDSThemeProvider: React.FC<SDSThemeProviderProps> = ({
    children,
    innerWrapperStyles,
    themeKey,
    ...rest
}) => {
    const theme = useMemo(() => {
        return getTheme(themeKey);
    }, [themeKey]);

    const themeClasses = useMemo(() => {
        return getThemeClasses(themeKey);
    }, [themeKey]);

    return (
        <SDSThemeContext.Provider value={theme}>
            <StyledThemeProvider innerWrapperStyles={innerWrapperStyles} className={themeClasses} {...rest}>
                {children}
            </StyledThemeProvider>
        </SDSThemeContext.Provider>
    );
};

SDSThemeProvider.displayName = "SDSThemeProvider";
